<template>
  <div class="pa-0 ma-0">
    <LoginForm mode="login" :response="message" v-on:form-submitted="login">
      <template v-slot:buttons>
        <v-btn text color="primary" class="text-none" to="/register">Register</v-btn>
        <v-btn text color="primary" class="text-none" to="/reset_password">Reset Password</v-btn>
      </template>
    </LoginForm>
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue';

export default {
  name: 'Login',
  components: { LoginForm },
  data: () => ({
    dialog: false,
    message: {
      content: '',
      color: 'black',
    },
  }),
  methods: {
    login(data) {
      const url = 'https://portal.beyondlabz.com/auth/login';
      this.$http.post(url, data)
        .then((resp) => {
          if (resp.status === 200) {
            console.log('loginDetails: ', resp.data);
            let success = false;
            if (typeof resp.data !== 'undefined' && resp.data.login === 1) success = true;
            if (success) {
              this.$store.commit('SET_USER', resp.data);
              this.$router.push('/');
            } else {
              this.message.content = 'Please check your user name and password and try again.';
              this.message.color = 'red';
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
